// 2022 national result summary, rendered as a compact dark card that
// overlays the empty sea area in the top-right of the map shell. Same
// numbers as before (PL/PN/Others/Turnout, headline margin) — just
// reformatted to fit a corner panel rather than a full-width band.

import { MAP_DATA } from '../../lib/buildMapPaths';
import './NationalResult.css';

const ELECTION_LABEL = '2022 General Election';

export default function NationalResult() {
  const n = MAP_DATA.national;
  if (!n) return null;
  const margin = n.pl_pct - n.pn_pct;
  const winner = margin >= 0 ? 'PL' : 'PN';
  const winnerColor = winner === 'PL' ? 'var(--party-pl)' : 'var(--party-pn)';
  const sign = margin >= 0 ? '+' : '−';

  return (
    <aside className="national-result" aria-label="2022 national result">
      <p className="national-result__eyebrow">{ELECTION_LABEL}</p>
      <p className="national-result__headline" style={{ color: winnerColor }}>
        {winner} won · {sign}
        {Math.abs(margin).toFixed(1)}pp
      </p>
      <dl className="national-result__stats">
        <div className="national-result__stat" style={{ borderTopColor: 'var(--party-pl)' }}>
          <dt>PL</dt>
          <dd>{n.pl_pct.toFixed(1)}%</dd>
        </div>
        <div className="national-result__stat" style={{ borderTopColor: 'var(--party-pn)' }}>
          <dt>PN</dt>
          <dd>{n.pn_pct.toFixed(1)}%</dd>
        </div>
        <div className="national-result__stat">
          <dt>Others</dt>
          <dd>{n.others_pct.toFixed(1)}%</dd>
        </div>
        <div className="national-result__stat">
          <dt>Turnout</dt>
          <dd>{n.turnout_pct.toFixed(1)}%</dd>
        </div>
      </dl>
    </aside>
  );
}
